import { Link } from "react-router-dom";
import AnimatedSection from "./AnimatedSection";
import PointedSectionBackground from "./PointedSectionBackground";

const BusinessMottoSection = () => {
  return (
    <section aria-labelledby="business-motto-title" className="relative z-10 pt-20 pb-10 md:pt-28 md:pb-14">
      <PointedSectionBackground bodyClassName="business-motto-body" />
      <div className="container mx-auto">
        <AnimatedSection className="mx-auto">
          <div className="flex flex-col py-12 justify-between gap-4 md:gap-20 sm:flex-row sm:items-end">
            <h2
              id="business-motto-title"
              className="min-w-0 text-4xl font-bold uppercase tracking-widest text-secondary-foreground sm:text-5xl md:text-5xl lg:text-6xl"
              style={{ lineHeight: 1.1 }}
            >
              We don&apos;t just make games. We make players want to go <span className="text-blood-red">Rogue.</span>
            </h2>
            <Link
              to="/about"
              className="btn-outline-light inline-flex w-full shrink-0 items-center justify-center gap-3 group sm:w-auto md:mb-[2px]"
            >
              About Us
              <svg
                className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </Link>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default BusinessMottoSection;
